export { default } from './AlertsCenterPage';
